import { type JudicialPreanalysis, type JudicialRecord } from '../model'

const DEFAULT_BASE_PILOTE_URL = `${import.meta.env.VITE_PILOTE_BASE_URL}/app/volunteer`

const volunteerFileUrl = (code: string, piloteIds: number[], basePiloteUrl: string): string => {
  if (piloteIds.length === 1) {
    return `${basePiloteUrl}/${piloteIds[0]}`
  }
  return `${basePiloteUrl}?filter=AllCentrals&keyword=${code}`
}

export const volunteerPiloteUrl = (record: JudicialRecord, basePiloteUrl = DEFAULT_BASE_PILOTE_URL): string =>
  volunteerFileUrl(
    record.volunteer.code,
    record.volunteer.ids.map(({ piloteId }) => piloteId),
    basePiloteUrl
  )

export const preanalysisVolunteerPiloteUrl = (
  preanalysis: JudicialPreanalysis,
  basePiloteUrl = DEFAULT_BASE_PILOTE_URL
): string => {
  const volunteerIds = (preanalysis.centrals ?? []).map(({ volunteerId }) => volunteerId)
  return volunteerFileUrl(
    preanalysis.personCode,
    volunteerIds.every((volunteerId): volunteerId is number => volunteerId !== null) ? volunteerIds : [],
    basePiloteUrl
  )
}
